<section aria-labelledby="details-title">
    <sirius-container>
        <div class="details">
            <sirius-heading
                id="details-title"
                textStyleCategory="title"
                textStyleSize="l"
                [text]="title!"
                data-cy="name">
            </sirius-heading>

            <sirius-text-html [html]="description ?? ''" data-cy="description"></sirius-text-html>

            @if (socialMediaLinks.length > 0) {
                <ur-social-media-links
                    [socialMediaLinks]="socialMediaLinks"
                    [title]="socialMediaTitle"
                    data-cy="social-media-links">
                </ur-social-media-links>
            }
        </div>
        <aside class="right-column">
            @if (logo) {
                <img class="logo" [src]="logo.image.url" [alt]="title" data-cy="logo" />
            }

            @if (highlights.length > 0 || !!formLink) {
                <div class="contact-details" data-cy="contact-details">
                    <ur-highlight [title]="textHighlightTitle">
                        @for (item of highlights; track $index) {
                            <ur-highlight-item [icon]="item.icon" [title]="item.label">
                                @if (item.address) {
                                    <a
                                        [siriusLink]="item.link"
                                        [ngClass]="{ 'secondary-link': item.type === 'secondary' }"
                                        data-cy="address">
                                        <address class="sir-text-style-paragraph-m-default">
                                            {{ item.address.street }}<br />
                                            {{ item.address.areaCode }} {{ item.address.city }}<br />
                                            {{ item.address.country }}
                                        </address>
                                    </a>
                                } @else {
                                    <a
                                        [siriusLink]="item.link"
                                        [ngClass]="{ 'secondary-link': item.type === 'secondary' }"
                                        class="sir-text-style-paragraph-m-default"
                                        data-cy="value">
                                        {{ item.link.title }}
                                    </a>
                                }
                            </ur-highlight-item>
                        }
                        @if (formLink) {
                            <a
                                siriusButton
                                [buttonText]="formLink.title"
                                [siriusLink]="formLink"
                                buttonType="primary"
                                iconName="envelope_open_duotone"
                                size="large"
                                data-cy="request-information-button">
                            </a>
                        }
                    </ur-highlight>
                </div>
            } @else if (config) {
                <div class="contact-details" data-cy="contact-details">
                    <ur-highlight [title]="textHighlightTitle">
                        @if (location) {
                            <ur-highlight-item [icon]="'map_pin_duotone'" [title]="location">
                                @if (street || city || country) {
                                    <address
                                        class="ur-highlights sir-text-style-paragraph-m-default">
                                        {{ street }}<br />
                                        {{ city }}<br />
                                        {{ country }}
                                    </address>
                                }
                            </ur-highlight-item>
                        }

                        @if (eventDateTime) {
                            <ur-highlight-item
                                [icon]="'calendar_blank_duotone'"
                                [title]="'page.event.dateTime' | translate">
                                {{ eventDateTime }}
                            </ur-highlight-item>
                        }

                        @if (languages.length) {
                            <ur-highlight-item [icon]="'globe_duotone'" [title]="'page.event.language' | translate">
                                @for (lang of languages; track $index) {
                                    <p class="ur-highlights">{{ lang }}</p>
                                }
                            </ur-highlight-item>
                        }
                    </ur-highlight>
                </div>
            }
        </aside>
    </sirius-container>
</section>
